// "use client";
//
// import { useState } from "react";
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/dialog";
// import { Calendar, Info } from "lucide-react";
//
// interface AnimalCardProps {
//   animal: any;
//   label?: string;
//   highlight?: boolean;
//   compact?: boolean;
// }
//
// export function AnimalCard({
//   animal,
//   label,
//   highlight = false,
//   compact = false,
// }: AnimalCardProps) {
//   const [isOpen, setIsOpen] = useState(false);
//
//   // Format birthdate or show age
//   const ageDisplay = animal.age ? `${animal.age} years old` : "Age unknown";
//   const formattedDate = animal.birthDate
//     ? new Date(animal.birthDate).toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "short",
//         day: "numeric",
//       })
//     : ageDisplay;
//
//   return (
//     <>
//       <div
//         className={`
//           relative rounded-lg overflow-hidden bg-lime-50 border z-50
// transition-all duration-200 shadow-amber-100 shadow-xl ${highlight ?
// "bg-lemon-400 border-primary shadow-md" : "border-gray-200
// hover:border-gray-300"} ${compact ? "bg-lemon-400 p-2 " : "bg-lemon-400 p-3"}
// cursor-pointer hover:shadow-sm `} onClick={() => setIsOpen(true)} > {label && (
// <div className={` absolute top-0 left-0 right-0 text-xs text-center py-1
// bg-purple-200 text-gray-700 font-medium ${compact ? "text-[10px] py-0.5" : ""} `}
// > {label} </div> )}  <div className={` flex ${compact ? "mt-3" : "mt-4"} ${label
// ? "pt-2" : ""}`} > <div className={`${compact ? "w-10 h-10" : "w-16 h-16"}
// relative rounded-full overflow-hidden flex-shrink-0`} > <img src={animal.image ??
// "/Placeholder-Bull.png"} alt={animal.name} className="w-full h-full object-cover"
// /> </div> <div className={`ml-3 ${compact ? "space-y-0.5" : "space-y-1"}`}> <h3
// className={`font-medium line-clamp-1 ${compact ? "text-sm" : ""}`} >
// {animal.name} </h3> <p className={`text-gray-500 line-clamp-1 ${compact ?
// "text-xs" : "text-sm"}`} > {animal.racialComposition} </p> {!compact && ( <div
// className="flex items-center text-xs text-gray-500"> <Calendar className="w-3 h-3
// mr-1" /> <span>{formattedDate}</span> </div> )} {animal.dgr && ( <p
// className={`text-gray-400 ${compact ? "text-xs" : "text-sm"}`}> DGR: {animal.dgr}
// </p> )} </div> </div> </div>  <Dialog open={isOpen} onOpenChange={setIsOpen}>
// <DialogContent className="sm:max-w-md"> <DialogHeader>
// <DialogTitle>{animal.name}</DialogTitle> </DialogHeader> <div className="grid
// gap-4 py-4"> <div className="flex items-start gap-4"> <div className="w-24 h-24
// relative rounded-md overflow-hidden flex-shrink-0"> <img src={animal.image ||
// "/placeholder.svg?height=96&width=96"} alt={animal.name} className="w-full h-full
// object-cover" /> </div> <div className="flex-1 grid gap-2"> <div> <h4
// className="text-sm font-medium text-gray-500">Breed</h4>
// <p>{animal.racialComposition}</p> </div> {animal.sex && ( <div> <h4
// className="text-sm font-medium text-gray-500">Sex</h4> <p>{animal.sex}</p> </div>
// )} {animal.coatColor && ( <div> <h4 className="text-sm font-medium
// text-gray-500">Color</h4> <p>{animal.coatColor}</p> </div> )} {animal.dgr && (
// <div> <h4 className="text-sm font-medium text-gray-500"> DGR Number </h4>
// <p>{animal.dgr}</p> </div> )} </div> </div>  <div className="grid grid-cols-2
// gap-4"> {animal.age && ( <div> <h4 className="text-sm font-medium text-gray-500
// mb-1"> Age </h4> <p>{animal.age} years</p> </div> )} {animal.weight && ( <div>
// <h4 className="text-sm font-medium text-gray-500 mb-1"> Weight </h4>
// <p>{animal.weight} kg</p> </div> )} </div>  {animal.birthDate && ( <div> <h4
// className="text-sm font-medium text-gray-500 mb-1"> Birth Date </h4> <div
// className="flex items-center"> <Calendar className="w-4 h-4 mr-2 text-gray-500"
// /> <span>{formattedDate}</span> </div> </div> )}  <div className="bg-green-300
// p-3 rounded-md"> <div className="flex items-start"> <Info className="w-4 h-4 mr-2
// text-gray-500 mt-0.5" /> <div className="text-sm text-gray-600"> <p> Click on
// related animals in the pedigree tree to explore their details and lineage. </p>
// </div> </div> </div> </div> </DialogContent> </Dialog> </> ); }

"use client";

import { Calendar, Info } from "lucide-react";
import {
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react"; // type Animal = {
// type Animal = {
//   id: string;
//   name: string;
//   breed: string;
//   birthDate: string;
//   awards: string[];
//   image: string;
//   color: string;
//   dgr: string;
//   sire: string | null;
//   dam: string | null;
//   // Additional fields from backend
//   sex?: string;
//   age?: number;
//   weight?: number;
// };

interface AnimalCardProps {
  animal: any;
  label?: string;
  highlight?: boolean;
  compact?: boolean;
}

export function AnimalCard({
  animal,
  label,
  highlight = false,
  compact = false,
}: AnimalCardProps) {
  // const [ setIsOpen] = useState(false);
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  // Format birth date or show age
  const ageDisplay = animal.age ? `${animal.age} months old` : "Age unknown";
  const formattedDate = animal.birthDate
    ? new Date(animal.birthDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : ageDisplay;

  return (
    <>
      <div
        className={`
          relative rounded-lg bg-slate-100 overflow-hidden border transition-all duration-200 shadow-lg shadow-amber-100
          ${highlight ? "border-primary shadow-md" : "border-gray-200 hover:border-gray-300"}
          ${compact ? "p-2" : "p-3"}
          cursor-pointer hover:shadow-sm
        `}
        onClick={onOpen}
      >
        {label && (
          <div
            className={`
            absolute top-0 left-0 right-0 text-xs text-center py-1 bg-slate-400 text-gray-700 font-medium
            ${compact ? "text-[10px] py-0.5" : ""}
          `}
          >
            {label}
          </div>
        )}

        <div
          className={`flex  ${compact ? "mt-3" : "mt-4"} ${label ? "pt-2" : ""}`}
        >
          <div
            className={`${compact ? "w-10 h-10" : "w-16 h-16"} relative rounded-full overflow-hidden flex-shrink-0`}
          >
            <Image
              loading={"lazy"}
              src={animal.image || "/placeholder.svg?height=64&width=64"}
              alt={animal.name}
              className="w-full h-full object-cover"
            />
          </div>
          <div className={`ml-3 ${compact ? "space-y-0.5" : "space-y-1"}`}>
            <h3
              className={`font-medium line-clamp-1 ${compact ? "text-sm" : ""}`}
            >
              {animal.name}
            </h3>
            <p
              className={`text-gray-500 line-clamp-1 ${compact ? "text-xs" : "text-sm"}`}
            >
              {animal.breed}
            </p>
            {!compact && (
              <div className="flex items-center text-xs text-gray-500">
                <Calendar className="w-3 h-3 mr-1" />
                <span>{formattedDate}</span>
              </div>
            )}
            {animal.dgr && (
              <p className={`text-gray-400 ${compact ? "text-xs" : "text-sm"}`}>
                DGR: {animal.dgr}
              </p>
            )}
          </div>
        </div>
      </div>

      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="flex flex-col gap-1 text-[#cfc130ff] bg-[#015354ff]">
                {animal.name}
              </ModalHeader>
              <ModalBody>
                <div className="grid gap-4 py-4">
                  <div className="flex items-start gap-4">
                    <div className="w-56 relative rounded-md overflow-hidden flex-shrink-0">
                      <Image
                        loading={"lazy"}
                        src={
                          animal.image || "/placeholder.svg?height=96&width=96"
                        }
                        alt={animal.name}
                        height={160}
                        width={250}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <div className="flex-1 grid gap-2">
                      <div>
                        <h4 className="text-sm font-medium text-gray-500">
                          Breed
                        </h4>
                        <p>{animal.breed}</p>
                      </div>
                      {animal.sex && (
                        <div>
                          <h4 className="text-sm font-medium text-gray-500">
                            Sex
                          </h4>
                          <p>{animal.sex}</p>
                        </div>
                      )}
                      {animal.color && (
                        <div>
                          <h4 className="text-sm font-medium text-gray-500">
                            Color
                          </h4>
                          <p>{animal.color}</p>
                        </div>
                      )}
                      {animal.dgr && (
                        <div>
                          <h4 className="text-sm font-medium text-gray-500">
                            DGR Number
                          </h4>
                          <p>{animal.dgr}</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    {animal.age && (
                      <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-1">
                          Age
                        </h4>
                        <p>{animal.age} months</p>
                      </div>
                    )}
                    {animal.weight && (
                      <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-1">
                          Weight
                        </h4>
                        <p>{animal.weight} kg</p>
                      </div>
                    )}
                  </div>

                  {animal.birthDate && (
                    <div>
                      <h4 className="text-sm font-medium text-gray-500 mb-1">
                        Birth Date
                      </h4>
                      <div className="flex items-center">
                        <Calendar className="w-4 h-4 mr-2 text-gray-500" />
                        <span>{formattedDate}</span>
                      </div>
                    </div>
                  )}

                  <div className="bg-gray-50 p-3 rounded-md">
                    <div className="flex items-start">
                      <Info className="w-4 h-4 mr-2 text-[#008c8fff] mt-0.5" />
                      <div className="text-sm text-gray-600">
                        <p>
                          Click on related animals in the pedigree tree to
                          explore their details and lineage.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>

      {/* <Dialog open={isOpen} onOpenChange={setIsOpen}> */}
      {/*   <DialogContent className="sm:max-w-md"> */}
      {/*     <DialogHeader> */}
      {/*       <DialogTitle>{animal.name}</DialogTitle> */}
      {/*     </DialogHeader> */}
      {/*     <div className="grid gap-4 py-4"> */}
      {/*       <div className="flex items-start gap-4"> */}
      {/*         <div className="w-56 relative rounded-md overflow-hidden flex-shrink-0"> */}
      {/*           <Image */}
      {/*             loading={"lazy"} */}
      {/*             src={animal.image || "/placeholder.svg?height=96&width=96"} */}
      {/*             alt={animal.name} */}
      {/*             height={160} */}
      {/*             width={250} */}
      {/*             className="w-full h-full object-contain" */}
      {/*           /> */}
      {/*         </div> */}
      {/*         <div className="flex-1 grid gap-2"> */}
      {/*           <div> */}
      {/*             <h4 className="text-sm font-medium text-gray-500">Breed</h4> */}
      {/*             <p>{animal.breed}</p> */}
      {/*           </div> */}
      {/*           {animal.sex && ( */}
      {/*             <div> */}
      {/*               <h4 className="text-sm font-medium text-gray-500">Sex</h4> */}
      {/*               <p>{animal.sex}</p> */}
      {/*             </div> */}
      {/*           )} */}
      {/*           {animal.color && ( */}
      {/*             <div> */}
      {/*               <h4 className="text-sm font-medium text-gray-500">Color</h4> */}
      {/*               <p>{animal.color}</p> */}
      {/*             </div> */}
      {/*           )} */}
      {/*           {animal.dgr && ( */}
      {/*             <div> */}
      {/*               <h4 className="text-sm font-medium text-gray-500"> */}
      {/*                 DGR Number */}
      {/*               </h4> */}
      {/*               <p>{animal.dgr}</p> */}
      {/*             </div> */}
      {/*           )} */}
      {/*         </div> */}
      {/*       </div> */}

      {/*       <div className="grid grid-cols-2 gap-4"> */}
      {/*         {animal.age && ( */}
      {/*           <div> */}
      {/*             <h4 className="text-sm font-medium text-gray-500 mb-1"> */}
      {/*               Age */}
      {/*             </h4> */}
      {/*             <p>{animal.age} months</p> */}
      {/*           </div> */}
      {/*         )} */}
      {/*         {animal.weight && ( */}
      {/*           <div> */}
      {/*             <h4 className="text-sm font-medium text-gray-500 mb-1"> */}
      {/*               Weight */}
      {/*             </h4> */}
      {/*             <p>{animal.weight} kg</p> */}
      {/*           </div> */}
      {/*         )} */}
      {/*       </div> */}

      {/*       {animal.birthDate && ( */}
      {/*         <div> */}
      {/*           <h4 className="text-sm font-medium text-gray-500 mb-1"> */}
      {/*             Birth Date */}
      {/*           </h4> */}
      {/*           <div className="flex items-center"> */}
      {/*             <Calendar className="w-4 h-4 mr-2 text-gray-500" /> */}
      {/*             <span>{formattedDate}</span> */}
      {/*           </div> */}
      {/*         </div> */}
      {/*       )} */}

      {/*       <div className="bg-gray-50 p-3 rounded-md"> */}
      {/*         <div className="flex items-start"> */}
      {/*           <Info className="w-4 h-4 mr-2 text-gray-500 mt-0.5" /> */}
      {/*           <div className="text-sm text-gray-600"> */}
      {/*             <p> */}
      {/*               Click on related animals in the pedigree tree to explore */}
      {/*               their details and lineage. */}
      {/*             </p> */}
      {/*           </div> */}
      {/*         </div> */}
      {/*       </div> */}
      {/*     </div> */}
      {/*   </DialogContent> */}
      {/* </Dialog> */}
    </>
  );
}
